var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpatialSpan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#FAC1B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 14,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#FAC1B5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 14,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#FAC1B5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 40,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#FAC1B5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#FAC1B5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 40,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#FAC1B5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 66,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#FAC1B5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 66,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#FAC1B5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 66,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#FAC1B5"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#C75E5A"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#F9907B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 66,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#C75E5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpatialSpan);
export default __webpack_public_path__ + "static/media/SpatialSpan.45b7068b650594d5aa53dfaca2013fca.svg";
export { ForwardRef as ReactComponent };